export default __webpack_public_path__ + "static/media/banner-mobile.8dea39a0.webp";